import React, { createContext, useEffect, useState } from "react";
import TreeForm from "./TreeFormV2";
import { Container, Form, Spinner } from "react-bootstrap";
import { PAGE_TOP_DESKTOP } from "../../utilities/constants";
import ErrorPage from "../ErrorPage/ErrorPage";
import { Link } from "react-router-dom";
import { Prompt, useParams } from "react-router";
import api from "../../apis/selectree_api";

import { useDispatch, useSelector } from "react-redux";
import { getSearchChar } from "../../actions/searchChar";

// action creators
import { getTreeDetail } from "../../actions/treeDetail";
import { getAuthHeader } from "../../utilities/header";

function checkMandatoryFields(treeData) {
  //appraisal
  if (treeData.appraisal == "Yes") {
    if (!treeData.app_lcant || !treeData.app_grrating) {
      alert("Please fill out all appraisal fields");
      return false;
    }
  }
  return true;
}

export const EditTreeContext = createContext(null);

function EditForm() {
  const { treeName: tree_id } = useParams();
  const dispatch = useDispatch();
  const tree_detail = useSelector(state => state.treeDetail);
  const tree_detail_match = tree_detail && tree_detail.tree_id === tree_id;

  const [loading, setLoading] = useState(tree_detail_match);
  const [state, setState] = useState(false);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    try {
      dispatch(getSearchChar());
      dispatch(getTreeDetail(tree_id)).then(res => {
        setState(res.payload);
        setLoading(false);
      });
    } catch (err) {
      console.log(`components.TreeDetail.useEffect: ${err}`);
    }
  }, [tree_id]);

  if (
    (loading && !(tree_detail && tree_detail.tree_id === tree_id)) ||
    !state
  ) {
    return (
      <Container xs={{ span: 4, offset: 4 }} className="text-center">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!tree_detail) {
    return (
      <Container xs={{ span: 4, offset: 4 }} className="text-center">
        <ErrorPage
          message={"There are no trees found that match that query."}
        />
      </Container>
    );
  }

  async function duplicateTree(e) {
    try {
      if (tree_id) {
        let response = await api.put(
          `/tree/v2/duplicate`,
          tree_detail,
          getAuthHeader()
        );
        window.location.href = `tree-detail/${response.data.tree_id}/edit`;
        //redirect to new tree with id
      } else {
        throw new Error("no id provided");
      }
    } catch (err) {
      console.log(`Error in client.components.EditTree.duplicateTree: ${err}`);
    }
  }

  async function deleteTree(e) {
    try {
      if (tree_id) {
        if (
          window.confirm(
            "Are you sure you wish to delete? There is NO undoing this action."
          )
        ) {
          await api.delete(`/tree/delete/${tree_id}`, getAuthHeader());
          window.location.href = `/`;
        }
      } else {
        throw new Error("no id provided");
      }
    } catch (err) {
      console.log(`Error in client.components.EditTree.deleteTree: ${err}`);
    }
  }

  //This is for both legacy and not components. Ideally we move to just use this
  function handleForm(name, value) {
    if (!name) return;

    if (Array.isArray(name) && Array.isArray(value)) {
      let new_state = { ...state };
      for (let i = 0; i < name.length && i < value.length; i++) {
        new_state[name[i]] = value[i];
      }
      setState(new_state);
    } else {
      setState({ ...state, [name]: value });
    }
    setChanged(true);
  }

  //This is for legacy consumers that had a class base compoennt as parent
  function updateState(new_state) {
    setState({ ...state, ...new_state });
  }

  async function submitForm(e) {
    setLoading(true);

    if (!checkMandatoryFields(state)) return;

    try {
      if (tree_id) {
        await api.put(`/tree/update/${tree_id}`, state, getAuthHeader());

        //Bit lazy way of fetch more data
        dispatch(getTreeDetail(tree_id)).then(res => {
          setChanged(false);
          setLoading(false);
        });
        //this.setState({ forceData: true, changed: false });
      } else {
        throw new Error("no id provided");
      }
    } catch (err) {
      console.log(`Error in client.components.EditTree.submitForm: ${err}`);
    }
  }

  return (
    <Container>
      <Prompt
        when={changed}
        message="Are you sure you wish to leave the page? Changes you made may not be saved."
      />

      <h2 className="text-center category-label p-3 pt-lg-5 pb-lg-11 m-0">
        Edit Tree #{tree_detail.tree_id}
      </h2>

      <div style={{ textAlign: "center", marginBottom: ".5rem" }}>
        <span onClick={duplicateTree} className="form-button-primary">
          Duplicate This Tree
        </span>
        &nbsp;
        <Link
          className="form-button-primary"
          to={`/tree/detail/${tree_detail.tree_id}`}
          onClick={() => window.scrollTo(PAGE_TOP_DESKTOP)}
        >
          Back to Tree Page
        </Link>
        &nbsp;
      </div>

      <Form
        onChange={e => {
          let input_value = e.target.getAttribute("data-value");
          if (input_value) {
            if (!isNaN(input_value)) {
              input_value = parseFloat(input_value);
            }
            handleForm(e.target.name, input_value);
          } else {
            handleForm(e.target.name, e.target.value);
          }
        }}
      >
        <EditTreeContext.Provider value={state}>
          <TreeForm
            state={state}
            setState={updateState}
            handleForm={handleForm}
          />
        </EditTreeContext.Provider>
      </Form>

      <div style={{ textAlign: "center", marginBottom: ".5rem" }}>
        <span
          onClick={submitForm}
          className={loading ? "form-button-secondary" : "form-button-primary"}
        >
          {" "}
          {loading ? "Saving..." : "Submit Form"}
        </span>
        &nbsp;
        <Link
          className="form-button-primary"
          to={`/tree/detail/${tree_detail.tree_id}`}
          // A timeout is need on this scroll for some reason
          onClick={() =>
            setTimeout(function () {
              window.scrollTo(PAGE_TOP_DESKTOP);
            }, 2)
          }
        >
          Back to Tree Page
        </Link>
        &nbsp;
        <span onClick={deleteTree} className="form-button-secondary">
          {" "}
          Permanently Delete{" "}
        </span>
      </div>
    </Container>
  );
}

export default EditForm;
